// extracted by mini-css-extract-plugin
module.exports = {"container":"more-info-section_container__NO_bD"};